// Amounts arrive as decimal strings; keep them exact in the table and CSV.
export function reviewAmount(value) {
  const text = String(value);
  if (!/^-?\d+\.\d{2}$/.test(text)) throw new Error('Invalid review amount');
  return text;
}

export function reviewMoney(value) {
  return `$ ${reviewAmount(value).replace(/\B(?=(\d{3})+\.)/g, ',')}`;
}

function csvText(value) {
  let text = value == null ? '' : String(value);
  if (/^\s*[=+\-@]/.test(text) || /^[\t\r\n]/.test(text)) text = "'" + text;
  return '"' + text.replace(/"/g, '""') + '"';
}

export function reviewCsv(data) {
  const lines = [
    ['Invoice No.', data.invoiceNumber],
    ['Carrier', data.logisticsCompany],
    ['File Name', data.fileName]
  ].map(row => row.map(csvText).join(','));
  lines.push('Current Charge Amt.,' + reviewAmount(data.currentChargeAmount));
  lines.push('Customer Charge Total,' + reviewAmount(data.customerChargeTotal));
  lines.push('', 'No.,Customer Invoice ID,Client Code,Charged Price');
  data.rows.forEach((row, index) => {
    lines.push([index + 1, csvText(row.customerInvoiceId || 'Not Invoiced'),
      csvText(row.clientCode), reviewAmount(row.chargedPrice)].join(','));
  });
  lines.push('Total,,,' + reviewAmount(data.customerChargeTotal));
  return '\uFEFF' + lines.join('\r\n') + '\r\n';
}

export function reviewFilename(invoiceNumber) {
  return `Invoice_Review_${String(invoiceNumber || 'invoice').replace(/[<>:"/\\|?*\x00-\x1f]/g, '_')}.csv`;
}
